export class ILaya {
}
ILaya.Loader = null;
ILaya.Context = null;
ILaya.Browser = null;
ILaya.InputManager = null;
ILaya.Laya = null;
ILaya.loader = null;
ILaya.timer = null;
ILaya.systemTimer = null;
ILaya.physicsTimer = null;
ILaya.stage = null;
